import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialFacebookBoxIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M20.8917 2H3.10833C2.81506 2.00218 2.53442 2.11965 2.32703 2.32703C2.11965 2.53442 2.00218 2.81506 2 3.10833V20.8917C2.00218 21.1849 2.11965 21.4656 2.32703 21.673C2.53442 21.8803 2.81506 21.9978 3.10833 22H12.6833V14.2667H10.0833V11.2417H12.6833V9.01667C12.6833 6.43333 14.2583 5.025 16.575 5.025C17.35 5.025 18.125 5.025 18.9 5.14167V7.83333H17.3083C16.05 7.83333 15.8083 8.43333 15.8083 9.30833V11.2333H18.8083L18.4167 14.2583H15.8083V22H20.8917C21.1849 21.9978 21.4656 21.8803 21.673 21.673C21.8803 21.4656 21.9978 21.1849 22 20.8917V3.10833C21.9978 2.81506 21.8803 2.53442 21.673 2.32703C21.4656 2.11965 21.1849 2.00218 20.8917 2Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
